import React from 'react';

const PackagingRenderer = (props: any) => {
  const packaging = props?.data?.packaging ?? '';
  const description = props?.data?.packagingDescription
    ? `(${props?.data?.packagingDescription})`
    : '';

  return (
    <div>
      {`${packaging}`}
      <span className="supplementary-info">{` ${description}`}</span>
    </div>
  );
};

export default PackagingRenderer;
